import { IGetState, TBoardId, TListId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import {
    pushNotificationSet
} from '../../../../../../../../../rest/effects/pushNotificationSettings/pushNotificationSet';
import {
    getPushNotificationSettingsByBoardId
} from '../../../../../../../../../store/model/selectors/getPushNotificationSettingsByBoardId';
import {
    getPushNotificationListChangeToIds
} from '../../../../../../../../../store/model/selectors/getPushNotificationListChangeToIds';
import { EPushNotificationSettingsTypes } from '../../../../../../../../../types/rest/IRestPushNotificationSettings';

export const onListChangeToToggle = (
    boardId: TBoardId,
    listId: TListId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        let listChangeToIds = getPushNotificationListChangeToIds(getState(), boardId);
        let { scope, subscribeCases, types, moveToListIds } = getPushNotificationSettingsByBoardId(getState(), boardId);
        if (listChangeToIds.includes(listId)) {
            listChangeToIds = listChangeToIds.filter(item => item !== listId);
        } else {
            listChangeToIds = [...listChangeToIds, listId];
        }
        if (listChangeToIds.length && !types.includes(EPushNotificationSettingsTypes.LIST_CHANGE)) {
            types = [...types, EPushNotificationSettingsTypes.LIST_CHANGE];
        }
        dispatch(pushNotificationSet(boardId, scope, subscribeCases, types, moveToListIds, listChangeToIds));
    };
    return action;
};
